import { render, staticRenderFns } from "./stubs-table.vue?vue&type=template&id=41c36c86"
import script from "./stubs-table.vue?vue&type=script&lang=js"
export * from "./stubs-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports